import * as React from 'react';
import { SkeletonLoader } from '@grandvisionhq/elements';
import { useIntl } from '@grandvisionhq/state';

const Loader = ()=>{
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement(SkeletonLoader, {
        className: "myaccount-menu-loader",
        "data-t": "myaccount-menu-loader"
    }, /*#__PURE__*/ React.createElement("svg", {
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        height: "16",
        "aria-label": getLabel('common.loadingText')
    }, /*#__PURE__*/ React.createElement("rect", {
        width: "100%",
        height: "16",
        rx: "5",
        fill: "currentColor"
    })));
};
var Loader$1 = Loader;

export { Loader$1 as default };
//# sourceMappingURL=Loader.js.map
